import API from '@/api/index';
import { sendNotificationToUser } from '../../api/notification';

const notification = {
  state: {},

  mutations: {},

  actions: {
    sendNotification ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.notification.sendNotification(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data.data);
          } else {
            reject(response.data.data);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    getNotifications ({ commit }) {
      return new Promise((resolve, reject) => {
        API.notification.getNotifications().then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data.data);
          } else {
            reject(response.data.data);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    sendNotificationToUser ({ commit }, data) {
      return new Promise((resolve, reject) => {
        sendNotificationToUser(data).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default notification;



// WEBPACK FOOTER //
// ./src/store/modules/notification.js